import React, { useState } from 'react'
import { Popover, Button, Space } from 'antd';
import { ExclamationCircleTwoTone } from '@ant-design/icons';

const DeletePopover = ({ record, deleteHandler, children }) => {
  const [visible, setVisible] = useState(false)

  const handleDelete = () => {
    setVisible(false)
    deleteHandler(record.id)
  }

  const handleVisibleChange = visible => setVisible(visible)

  return (
    <Popover
      placement="topRight"
      content={
        <div style={{textAlign: 'right'}}>
          <Space>
            <Button onClick={() => handleVisibleChange(false)}>Cancel</Button>
            <Button danger onClick={handleDelete}>YES</Button>
          </Space>
        </div>
      }
      title={
        <div style={{ padding: '1em'}}>
        <ExclamationCircleTwoTone twoToneColor='red' style={{marginRight: 8}}/>
        Are you sure you want to delete this?
        <p style={{fontSize: '0.85em', marginTop: "1em"}}>{record.name}</p>
        </div>
      }
      trigger="click"
      visible={visible}
      onVisibleChange={handleVisibleChange}
    >
      { children }
    </Popover>
  );
}

export default DeletePopover;